/* global markUpCategoriesIndexUrl markUpCategoriesUpdateUrl markUpCategoriesCreateUrl markUpCategoriesDeleteUrl */

import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';
import { Modal } from 'flowbite';

import MarkUpCategoriesTableRow from './MarkUpCategoriesTableRow';
import MarkUpCategorySaveModal from './MarkUpCategorySaveModal';

import { modalOptions } from 'Helpers/modalOptions';

import Button from 'CommonComponents/Button';
import ConfirmationModal from 'CommonComponents/ConfirmationModal';

import useModal from 'Hooks/useModal';

import PlusIcon from 'Assets/icons/plus.svg';

const queryParams = new URLSearchParams(window.location.search);
const query = { action: queryParams.get('action') };

export default function MarkUpCategoriesTable(props) {
    const [categories, setCategories] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [updatedCategory, setUpdatedCategory] = useState({});
    const [deletedCategory, setDeletedCategory] = useState({});

    const [actionCompleted, setActionCompleted] = useState(false);
    const [actionInProgress, setActionInProgress] = useState(false);
    const [actionFailed, setActionFailed] = useState(false);

    const [markUpCategoriesDeleteModalElement, setMarkUpCategoriesDeleteModalElement] = useState(null);

    const markUpCategoriesDeleteModalRef = useRef();

    const markUpCategoriesCreateModal = useModal({ visible: query.action === 'create_create_category' });
    const markUpCategoriesEditModal = useModal();

    useEffect(() => {
        fetchCategories();

        markUpCategoriesDeleteModalRef && setMarkUpCategoriesDeleteModalElement(new Modal(markUpCategoriesDeleteModalRef.current, modalOptions(false)));
    }, []);
    useEffect(() => {
        if (Object.keys(updatedCategory).length > 0) {
            markUpCategoriesEditModal.show();
        }
    }, [updatedCategory]);

    useEffect(() => {
        if (Object.keys(deletedCategory).length > 0) {
            markUpCategoriesDeleteModalElement && markUpCategoriesDeleteModalElement.show();
        }
    }, [deletedCategory]);

    const fetchCategories = () => {
        setIsLoading(true);
        axios
            .untranslated()
            .get(props.indexUrl)
            .then((res) => {
                setCategories([...res.data.categories]);
            })
            .catch((e) => {
                setCategories([]);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const addNewCategory = () => {
        markUpCategoriesCreateModal.show();
    };

    const editCategory = (category) => {
        setUpdatedCategory(category);
    };

    const deleteCategory = (category) => {
        setDeletedCategory(category);
    };

    const successHandler = () => {
        setUpdatedCategory({});
        setDeletedCategory({});
        fetchCategories();
        markUpCategoriesCreateModal.hide();
        markUpCategoriesEditModal.hide();
        markUpCategoriesDeleteModalElement && markUpCategoriesDeleteModalElement.hide();
    };

    const closeModal = () => {
        setUpdatedCategory({});
        setDeletedCategory({});
        markUpCategoriesCreateModal.hide();
        markUpCategoriesEditModal.hide();
        markUpCategoriesDeleteModalElement && markUpCategoriesDeleteModalElement.hide();
    };

    const cleanConfirmationModalStates = () => {
        setActionInProgress(false);
        setActionFailed(false);
        setActionCompleted(false);
    };

    const triggerDeleteCategory = () => {
        setActionInProgress(true);

        axios
            .delete(props.deleteUrl.replace('CATEGORY_ID', deletedCategory.id), { data: {} })
            .then((response) => {
                response.data.deleted ? setActionCompleted(true) : setActionFailed(true);
            })
            .catch((e) => {
                setActionFailed(true);
            });
    };

    return (
        <div className="table__card">
            <div className="tw-flex tw-items-start tw-justify-between tw-mb-6">
                <h5 className="table__header">{$t('Mark Up Categories')}</h5>
                <div>
                    <Button variant="primary" onClick={addNewCategory} disabled={isLoading}>
                        <PlusIcon className="tw-w-3 tw-h-3" />
                        {$t('Create Category')}
                    </Button>
                </div>
            </div>
            <div className="inbud-table_wrapper">
                <table className="inbud-table">
                    <thead>
                        <tr>
                            <th className="tw-w-44">{$t('Category Name')}</th>
                            <th>{$t('Additional Info')}</th>
                            <th className="tw-w-40">{$t('Actions')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {categories.map((category) => {
                            return (
                                <MarkUpCategoriesTableRow key={category.id} category={category} editCategory={editCategory} deleteCategory={deleteCategory} />
                            );
                        })}
                    </tbody>
                </table>
            </div>

            <MarkUpCategorySaveModal
                id={'update-category'}
                modal={markUpCategoriesEditModal}
                closeHandler={closeModal}
                successHandler={successHandler}
                category={updatedCategory}
                updateUrl={props.updateUrl}
                action={'update'}
            />

            <ConfirmationModal
                closeHandler={closeModal}
                successHandler={successHandler}
                triggerAction={triggerDeleteCategory}
                cleanStates={cleanConfirmationModalStates}
                allowAction={Object.keys(deletedCategory).length > 0}
                modalId={'delete-category'}
                modalRef={markUpCategoriesDeleteModalRef}
                modalElement={markUpCategoriesDeleteModalElement}
                request={actionInProgress}
                actionCompleted={actionCompleted}
                actionFailed={actionFailed}
                confirmationMsg={$t('Are you sure you want to delete [{{category}}]', { category: deletedCategory?.name })}
                actionCompletedMsg={$t('[{{category}}] deleted', { category: deletedCategory?.name })}
                actionFailedMsg={$t('[{{category}}] could not be deleted', { category: deletedCategory?.name })}
                title={$t('Delete Mark Up Category')}
                cancelButtonText={$t('Cancel')}
                primaryButtonText={$t('Delete')}
            />

            <MarkUpCategorySaveModal
                id={'create-category'}
                modal={markUpCategoriesCreateModal}
                closeHandler={closeModal}
                successHandler={successHandler}
                category={{}}
                updateUrl={props.createUrl}
                action={'create'}
            />
        </div>
    );
}

if (document.getElementById('markUpCategories')) {
    var root = document.getElementById('markUpCategories');
    ReactDOM.render(
        <App>
            <MarkUpCategoriesTable
                indexUrl={markUpCategoriesIndexUrl}
                updateUrl={markUpCategoriesUpdateUrl}
                createUrl={markUpCategoriesCreateUrl}
                deleteUrl={markUpCategoriesDeleteUrl}
            />
        </App>,
        root,
    );
}
